import { useState } from 'react';
import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import { getTranslateByKey } from '@/main/services/utils';
import FiltersTireBrand from './filtersSearchTireBrand/filtersSearchTireBrand';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import { withQueryparams } from '@/main/components/core/queryParams/queryparams';
import GridSearchTireBrand from './gridTireBrand/gridTireBrandScreen';
import { TireBrandRequest } from '@/main/models/request/tireBrandRequest';
import { TireBrandResponse } from '@/main/models/response/tireBrandResponse';

function SearchTireBrandScreen() {
  const [dataGrid, setDataGrid] = useState<TireBrandResponse[]>([]);
  const [formFilters, setFormFilters] = useState<TireBrandRequest | null>(null);

  function onResetSearch() {
    setDataGrid([]);
    setFormFilters(null);
  }

  async function getDataTireBrand(
    filters: TireBrandRequest | Partial<TireBrandRequest> = {},
    isResetSearch: boolean = true
  ) {
    const request: TireBrandRequest = {
      ...(isResetSearch ? {} : formFilters),
      ...(filters as TireBrandRequest),
      pageIndex: PaginationEnum.PageIndexIntial,
      pageSize: PaginationEnum.PageSize30
    };

    onResetSearch();
    setFormFilters(request);
  }

  const titlePage = `${getTranslateByKey('module.registration')} > ${getTranslateByKey('information.tireBrand')}`;
  
  return (
    <ContainerScreen title={titlePage}>
      <FiltersTireBrand
        formFilters={formFilters}
        getDataTireBrand={getDataTireBrand}
        onResetSearch={onResetSearch}
      />
      {formFilters && (
        <GridSearchTireBrand
          formFilters={formFilters}
          dataGrid={dataGrid}
          setDataGrid={setDataGrid}
          getDataTireBrand={getDataTireBrand}
        />
      )}
    </ContainerScreen>
  );
}

export default withQueryparams(SearchTireBrandScreen);
